import { withFormik } from 'formik'
import * as yup from 'yup'
import api from './api'
import '../../utils/validations/extendYup'

// formik
export const mapPropsToValues = () => ({
  username: '',
  password: '',
  name: '',
  lastname: '',
  nif: '',
  phone: '',
  terms: false,
  power: false
})

export const validationSchema = yup.object().shape({
  username: yup
    .string()
    .email()
    .required(),
  password: yup
    .string()
    .password()
    .required(),
  // yup ref dont work when abortEarly is false (formik behaviour)
  // see https://github.com/jquense/yup/pull/410 (accepted but not published :)
  // when publish uncomment next line to cast duplication on confirm_password
  // confirm_password: yup.ref('password'),
  name: yup
    .string()
    .required(),
  lastname: yup
    .string()
    .required(),
  nif: yup
    .string()
    .nifNie()
    .required(),
  phone: yup
    .string()
    .phoneNumber()
    .required(),
  terms: yup
    .bool()
    .isTrue()
    .required(),
  power: yup
    .bool()
    .isTrue()
    .required()
})

export async function handleSubmit(values, {
  setSubmitting,
  setStatus
}) {
  try {
    // formik return the values of internal state
    // instead of yup.validate with casted values we cast again before submit
    const castedValues = validationSchema.cast(values)

    const result = await api.create({
      ...castedValues,
      // yup ref dont work when abortEarly is false (formik behaviour)
      // manually setted
      confirm_password: values.password
    })
    setStatus({ success: result.response })
  } catch (error) {
    setStatus({ error })
  } finally {
    setSubmitting(false)
  }
}

export default withFormik({
  mapPropsToValues,
  validationSchema,
  handleSubmit
})
